/** A runtime metric in hours, rendered the way the design does: `1200h` for a whole number of hours,
 *  `6h 43m` once there is a fractional part (Figma 294:259627 / 294:259669). Used by both Total
 *  active time and Avg runtime/day.
 *
 *  A never-active Device's `0` renders **`0h`** — a zero, deliberately not the `EMPTY_CELL` hyphen
 *  that `lastActiveOn` uses. The AC keeps those two placeholders distinct; do not merge them. */
export function formatRuntimeHours(hours: number): string {
  const minutes = Math.round(hours * 60);
  const wholeHours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  return remainder ? `${wholeHours}h ${remainder}m` : `${wholeHours}h`;
}
